import api from './apiSetup';
import { serialize } from './util';

export const fetchTemplates = params => {
  params = {
    ...params,
    related_searches: 1
  };
  const query = serialize(params);
  return api(`/templates?${query ? `&${query}` : ''}`);
};

export const fetchTemplate = templateId => {
  return api(`/templates/${templateId}`);
};

export default {
  fetchTemplates,
  fetchTemplate
};
